/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { useHistory } from 'react-router-dom';
import { Container, Row, Card, CardHeader, Button, CardBody } from 'reactstrap';
import SimpleHeader from '../../../components/Headers/SimpleHeader';

import ReactLoader from 'components/Loader';

import {
  icon_column_style,
  individual_icon_header_style
} from '../../../assets/styles/table_custom_style';
import Service from '../service';
import { toast } from 'react-toastify';

const AutomaticCloseChatConfig = () => {
  const [loading, setLoading] = useState(false);

  const [configs, setConfigs] = useState([]);

  const history = useHistory();

  const daysOfWeek = {
    monday: 'Segunda',
    tuesday: 'Terça',
    wednesday: 'Quarta',
    thursday: 'Quinta',
    friday: 'Sexta',
    saturday: 'Sábado',
    sunday: 'Domingo'
  };

  const days = Object.keys(daysOfWeek);

  useEffect(() => {
    handleGetData();
  }, []);

  function handleGetData() {
    setLoading(true);

    Service.find()
      .then((response) => {
        const configs = response.data.data;

        setLoading(false);

        configs.forEach((config, index) => {
          let listDays = [];

          days.forEach((day) => {
            if (config[day] === true)
              for (let [key, value] of Object.entries(daysOfWeek))
                if (key === day) listDays.push(value);
          });

          const joinDays = listDays.join(' , ');
          configs[index] = { ...config, joinDays };
        });
        setConfigs(configs);
      })
      .catch((error) => {
        console.error('Error fetching configurations:', error);
        setLoading(false);
        toast.error('Erro ao buscar configurações!');
      });
  }

  function handleDelete(id) {
    Service.delete(id)
      .then(() => {
        toast.success('Configuração excluída com sucesso!');
        history.push(`closeChatConfiguration`);
        handleGetData();
      })
      .catch((error) => {
        console.error('Error deleting configuration:', error);
        toast.error('Erro ao excluir configuração!');
      });
  }

  function handleUpdate(id) {
    history.push(`/admin/closeChatConfiguration/form/${id}`);
  }

  return (
    <>
      <SimpleHeader
        setCreate="/admin/closeChatConfiguration/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row className="mt-3 mx-2">
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '1rem',
                    alignItems: 'center'
                  }}
                >
                  <h3>Configurações de encerramento automático</h3>
                </CardHeader>
                <CardBody></CardBody>
                <ToolkitProvider
                  data={configs}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'queueName',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Fila',
                      formatter: (_, row) => {
                        return <span>{row.queueName}</span>;
                      }
                    },

                    {
                      dataField: 'closeMessage',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Mensagem de encerramento',
                      formatter: (_, row) => {
                        return <span>{row.closeMessage}</span>;
                      }
                    },
                    {
                      dataField: 'edit',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="info"
                            size="sm"
                            title={'Editar Configuração'}
                            onClick={() => handleUpdate(row.id)}
                          >
                            <li className="fas fa-edit"></li>
                          </Button>
                        );
                      }
                    },
                    {
                      dataField: 'delete',
                      style: icon_column_style,
                      headerStyle: individual_icon_header_style,
                      text: 'Excluir',
                      formatter: (_, row) => {
                        return (
                          <Button
                            color="danger"
                            size="sm"
                            title={'Excluir Configuração'}
                            onClick={() => handleDelete(row.id)}
                          >
                            <li className="fas fa-trash"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default AutomaticCloseChatConfig;
